import {useState, useCallback} from 'react'
import {CheckCircleFillIcon, ChevronDownIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import styles from './CompletedItems.module.css'

export interface CompletedItem {
  label: string
}

interface CompletedItemsDisclosureProps {
  items: CompletedItem[]
}

export function CompletedItemsDisclosure({items}: CompletedItemsDisclosureProps) {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  if (items.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={isOpen}
        onClick={toggle}
        aria-label={`${isOpen ? 'Collapse' : 'Expand'} completed items`}
      >
        <ChevronDownIcon size={16} className={clsx(styles.chevron, !isOpen && styles.chevronCollapsed)} />
        <span className={styles.toggleLabel}>See completed items ({items.length})</span>
      </button>
      {isOpen && (
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        <ul role="list" className={styles.list}>
          {items.map((item, index) => (
            <li key={`${item.label}-${index}`} className={styles.item}>
              <CheckCircleFillIcon size={16} className={styles.checkIcon} />
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
